export default "__VITE_ASSET__07012051__"